module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "notice_content_wrap",
    on: {
      "click": _vm.hideComponent
    }
  }, [_c('div', {
    staticClass: "notice_content"
  }, [_c('div', {
    staticClass: "notice_header"
  }, [_c('div', {
    staticClass: "close_btn",
    on: {
      "click": _vm.closeHandler
    }
  }, [_c('v-icon', [_vm._v("clear")])], 1), _vm._v(" "), _c('div', {
    staticClass: "header_title"
  }, [_vm._v(_vm._s(_vm.notice.title))])]), _vm._v(" "), _c('div', {
    staticClass: "content",
    attrs: {
      "id": "content"
    }
  })])])
},staticRenderFns: []}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler?{"id":"data-v-36f7b2a8","hasScoped":true,"transformToRequire":{"video":"src","source":"src","img":"src","image":"xlink:href"}}!./~/vue-loader/lib/selector.js?type=template&index=0!./src/components/mainScreen/NoticeDetail.vue
// module id = 841
// module chunks = 1